import {Component, Inject, OnInit, Optional, RESPONSE_INIT, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'mbnm-page-not-found',
    templateUrl: './page-not-found.component.html',
    styleUrls: ['./page-not-found.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PageNotFoundComponent implements OnInit {

  constructor(@Optional() @Inject(RESPONSE_INIT) private responseInit: ResponseInit | null) { }

  ngOnInit() {
    if (this.responseInit) {
      this.responseInit.status = 404;
      this.responseInit.statusText = '404 - Page Not Found';
    }
  }
}
